module.exports = __webpack_public_path__ + "img/newsImg11-14.70f859b3.png";